/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum BookingStatus {
  Unknown = 0,
  Created = 1,
  Completed = 10,
  Cancelled = 99,
}
